import { apiActionSms } from "../../CheckoutDefault/services/api";

export function checkoutAuthRequest({ token }) {
  return apiActionSms.get(
    "/checkout",
    {
      params: {
        token,
      },
    }
  );
}